export const pattern = {
  album: {
    name: /^[\w\s,()?'":-]{2,50}$/
  },
  login: {
    email: /^[a-z]{1,}([a-z\d._]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/,
    password: /^[\w]{8,}$/
  },
  post: {
    title: /^[\w\s,()?'":-]{2,50}$/
  },
  user: {
    name: /^[\w\s,-]{2,40}$/,
    permissions: /^([01]{2},){8}(1[01]{1},)([01]{2},){5}[01]{2}$/
  }
};

class ValidationHelper {
  static validate = (string: string, regex: RegExp): boolean => {
    return regex.test(string);
  };
}

export default ValidationHelper;
